// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"RoomNormsView_Wrapper__2XPac","Image":"RoomNormsView_Image__1AHEF","Text":"RoomNormsView_Text__1XaaI"};